import { checkEmbedIsString } from 'helpers/embed/embedTypeCheck.helper';

export const getLocationIdFromIriOrNumber = (
  location?: string | number | null
): number | undefined => {
  if (!location) {
    return undefined;
  }

  if (checkEmbedIsString(location)) {
    const id = parseInt(location.replace('/api/locations/', ''), 10);
    if (isNaN(id)) {
      return undefined;
    }
    return id;
  }
};
